/**
 * Resource nghiệp vụ chuyển kho
 * ndquang1 20.5.2024
 */
export default {
  Title: 'Kiểm kê',
  BackMoney: 'Lấy lại số tồn',
  GetData:'Lấy dữ liệu',
  InventoryValue: 'Kiểm kê giá trị',
  InventoryTab: {
    Title: 'Kiểm kê',
    Target: 'Mục đích',
    Stock: 'Kiểm kê kho',
    assetcategory : "Loại tài sản/tang vật",
    ToDate: 'Đến ngày',
    Object: 'Đối tượng',
    Date: 'Ngày',
    Hour: 'Giờ',
    No: 'Số',
    IncreamentAccount: 'TK đ/c tăng',
    IncreamentAccountTooltip: 'Tài khoản điều chỉnh tăng',
    DecreaseAccount: 'TK đ/c giảm',
    DecreaseAccountTooltip: 'Tài khoản điều chỉnh giảm',
  },
  MemberTab: {
    Title: 'Thành viên tham gia',
  },
  ResultTab: {
    Title: 'Kết quả xử lý',
    Reason: 'Lý do',
    Conclude: 'Kết luận',
    Resolved: 'Đã xử lý chênh lệch',
    ResolvedUperCase: 'ĐÃ XỬ LÝ CHÊNH LỆCH',
  }
};
